import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { orderGroupIdZodSchema } from "@@/shared/order-groups/order-group-id";
import { orderIdZodSchema } from "@@/shared/orders/order-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { z } from "zod";
import { tokenizedCardDataZodObject } from "./tokenized-card";

const chargeTokenizedCardCommandZodObject = z.object({
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("CHARGE_TOKENIZED_CARD_COMMAND"),
    providerId: providerIdZodSchema,
    tokenizedCardData: tokenizedCardDataZodObject,
    orderGroupId: orderGroupIdZodSchema,
    orderId: orderIdZodSchema,
    /** Amount will be calculated and verified to be the same at server side */
    amountToPayInclVat: z.number().positive().min(1).int(),
});
type ChargeTokenizedCardCommand = z.infer<
    typeof chargeTokenizedCardCommandZodObject
>;

const chargeTokenizedCardCommandFactoryParamsZodObject =
    chargeTokenizedCardCommandZodObject.omit({
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof chargeTokenizedCardCommandFactoryParamsZodObject
>;
const chargeTokenizedCardCommandFactory = (
    params: FactoryParams,
): ChargeTokenizedCardCommand => {
    const command: ChargeTokenizedCardCommand = {
        _createdAt: nowIsoAndUnix(),
        _type: "CHARGE_TOKENIZED_CARD_COMMAND",
        ...params,
    };
    return command;
};

export {
    chargeTokenizedCardCommandFactory,
    chargeTokenizedCardCommandFactoryParamsZodObject,
    chargeTokenizedCardCommandZodObject,
};
export type {
    ChargeTokenizedCardCommand,
    FactoryParams as ChargeTokenizedCardCommandFactoryParams,
};
